import styled from 'styled-components'

const FormGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  column-gap: ${props => props.theme.spacing.base400};
`

export default FormGroup
